import QuoteYesNoQuestion from "../../components/inputs/QuoteYesNoQuestion";

export default function AdQuestion({ adQuestion, updateAnswerByFieldName }: any) {
    return (
        <div className="selection-container">
            <QuoteYesNoQuestion
                label={adQuestion.questionSetQuestion.text}
                value={adQuestion.answer}
                onChange={(value: string) =>
                    updateAnswerByFieldName(adQuestion.questionSetQuestion.answerFieldName, value)
                }
            />
        </div>
    )
}